ValidationEngine = App.loadClass "core::ValidationEngine"
InviteTab = App.loadClass "grower::handlers/contacts/tabs/Invite_Tab_Handler"


class exports.Add_Permission_Dialog extends DialogHandler

    init: () ->
        ths = this
        @layoutUrl = 'backend/grower/contacts/addpermissionform'
        @classes = 'large_dialog'
        @saveUrl = 'backend/grower/contacts/addpermission-ajax'
        @refreshNavHandler = false

        @validator = new ValidationEngine()

        ## Update DDMs ##
        @successAction = (data) ->
            for i, v of App.current_page.activeSubHandlers
                if(v instanceof InviteTab)
                    $(v.layoutSelector).find('.btn-search').click() #re-run search
                else
                    App.current_page.refreshSubHandlers()

        @createDialog()


    afterLoadLayout: () ->
        self = this
        @openDialog()

        @getPermission null, () ->
            self.setPosition()

        @validator.makeFormValidator 'addPermission', '#frm_addpermission', '#errorDiv', (valid) =>
            if (valid)
                @save('Adding New Permission...')

        @validator.registerRule
            'selector': '.validate-permission'
            'text': 'The permission name you entered needs to be unique from your other permission names.'
            'ajax':
                'url': 'backend/grower/contacts/validate-permission'
                'data': (elem) ->
                    'permission_name': elem.val()
            'func': (data) ->
                return data is 'valid'

        @submitAction = () =>
            @validator.validateAll()


    getPermission: (id = null, callback = null) ->
        @dialog.find('.message_writer').message_writer('info', 'Loading...')

        idv = if id then id: id else null
        $.post 'backend/grower/contacts/get-permissionform-ajax', idv, (response) =>
            cdata = response.data

            render = @dialog.find(".permissions-template").render(cdata)
            @dialog.find('.permissions-table-wrapper').html(render)

            @dialog.find('#frm_addpermission').show()

            @dialog.find('.message_writer').message_writer('success', 'Loaded')
            @dialog.find('.message_writer').message_writer('hide')

            ## View and Add, select or deselect entire columns ##
            @dialog.find('.multi-control').click (e) ->

                if $(this).is('.view')
                    affectClass = '.con_addView'
                else if $(this).is('.add')
                    affectClass = '.con_addAdd'
                affect = affectClass + " :checkbox"

                table = $(this).parents('table')
                checkboxes = $(table).find(affect)

                unchecked = false
                checkboxes.each () ->
                    if not $(this).prop('checked')
                        unchecked = true
                        $(this).prop('checked', true)

                if not unchecked
                    checkboxes.each () ->
                        $(this).prop('checked', false)

            callback?()
